// eslint-disable-next-line
import React, { useState, useContext, useEffect } from "react";
import {
  StyledExercise,
  StyledOptionsList
} from './MultipleChoice.styled'

import Question from '../Question'
import Button from '../Button'
import useResponse from '../../hooks/useResponse'

const MultipleChoice = ({ component, intlKey, pagingInfo }) => {
  const [gameState, setGameState] = useState(component.options)
  const [failedGame, setFailedGame] = useState(false)
  const [feedback, setFeedback] = useState('')
  const correctAnswers = gameState
    .filter(opt => opt.isCorrect === true)
    .map(opt => opt.id)
  const [correctGuesses, setCorrectGuesses] = useState([])

  const resetGame = () => {
    setGameState([...component.options])
    setFailedGame(false)
    setFeedback('')
    setCorrectGuesses([])
    close()
  }
  const [Response, open, close, isOpen, completeTask] = useResponse('root', pagingInfo, resetGame)

  const handleClick = index => {
    const option = gameState[index]
    option.clicked = true
    if (option.isCorrect) {
      correctGuesses.push(option.id)
      if (correctGuesses.length === correctAnswers.length) {
        setFeedback(option.feedbackTextID || component.rightFeedbackID)
        open()
        completeTask()
      }
    } else {
      setFeedback(option.feedbackTextID || component.wrongFeedbackID)
      open()
      setFailedGame(true)
    }
    setGameState([...gameState])
  }

  useEffect(() => {
    setCorrectGuesses(correctGuesses)
    return () => {
      gameState.forEach(option => { option.clicked = false })
      setGameState([...gameState])
    }
    // eslint-disable-next-line
  }, [correctGuesses, setCorrectGuesses])

  const options = gameState.map((option, index) => (
    <Button
      handleClick={() => !failedGame && !option.clicked && handleClick(index)}
      key={`Option-${option.textID || option.src}`}
      classes={[option.clicked ? 'clicked' : '', 'mc-option']}
      clicked={option.clicked}
      icon
      isCorrect={option.isCorrect}
      index={index}
      styling={component.styling}
      tabIndex={index + 10}
      feedbackTextID={option.feedbackTextID}
      text={intlKey + option.textID}
    />
  ))

  return (
    <StyledExercise>
      <Question instructionID={component.instructionID} questionID={component.questionID} hintID={component.hintID} intlKey={intlKey} />
      <StyledOptionsList>{options}</StyledOptionsList>
      {isOpen && <Response maskColor={failedGame ? 'wrong' : 'right'} textID={intlKey + feedback} />}
    </StyledExercise>
  )
}
//

// export default withRouter(MultipleChoice);
export default MultipleChoice
